import { useState } from 'react'
import { messagesApi } from '../../api/messages'
import { useChatStore } from '../../stores/chatStore'
import { useUiStore } from '../../stores/uiStore'
import { Modal } from '../ui/Modal'
import { Avatar } from '../ui/Avatar'
import { Spinner } from '../ui/Spinner'
import type { Chat, Message } from '../../types'
import { chatTitle } from '../../lib/displayName'

interface Props {
  message: Message
  onClose: () => void
}

export function ForwardModal({ message, onClose }: Props) {
  const { chats } = useChatStore()
  const { addToast } = useUiStore()
  const [search, setSearch] = useState('')
  const [forwarding, setForwarding] = useState<string | null>(null)

  const filtered = chats.filter((c) => {
    const name = chatTitle(c)
    return name.toLowerCase().includes(search.toLowerCase())
  })

  const forward = async (chat: Chat) => {
    setForwarding(chat.id)
    try {
      await messagesApi.forward(message.chat_id, [message.id], chat.id)
      addToast('success', 'Сообщение переслано')
      onClose()
    } catch {
      // Fallback: copy text as new message
      try {
        await messagesApi.send(chat.id, { text: message.text })
        addToast('success', 'Сообщение переслано')
        onClose()
      } catch {
        addToast('error', 'Не удалось переслать сообщение')
      }
    } finally {
      setForwarding(null)
    }
  }

  return (
    <Modal onClose={onClose} title="Переслать в...">
      <div className="p-3">
        <input
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Поиск чатов..."
          autoFocus
          className="w-full bg-bg-input rounded-xl px-3 py-2 text-sm text-txt-primary
                     outline-none focus:ring-1 focus:ring-accent placeholder-txt-meta"
        />
        <div className="mt-2 space-y-0.5 max-h-80 overflow-y-auto">
          {filtered.map((chat) => (
            <button
              key={chat.id}
              onClick={() => forward(chat)}
              disabled={!!forwarding}
              className="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl hover:bg-bg-hover
                         text-left disabled:opacity-60 transition-colors"
            >
              <Avatar
                name={chatTitle(chat)}
                src={chat.avatar_url ?? chat.peer?.avatar_url}
                size={36}
              />
              <span className="flex-1 text-txt-primary text-sm">
                {chatTitle(chat)}
              </span>
              {forwarding === chat.id && <Spinner size={16} />}
            </button>
          ))}
          {filtered.length === 0 && (
            <p className="text-txt-secondary text-sm text-center py-6">Чаты не найдены</p>
          )}
        </div>
      </div>
    </Modal>
  )
}
